// extracted by mini-css-extract-plugin
export default {"title":"feature-title_title__xvLVH"};